export const toCSV = (rows: any[]): string => {
  if (!rows || rows.length === 0) {
    return '';
  }

  const headerSet = rows.reduce((set: Set<string>, row: any) => {
    if (row && typeof row === 'object') {
      Object.keys(row).forEach(k => set.add(k));
    }
    return set;
  }, new Set<string>());

  const headers = Array.from(headerSet);

  const escapeValue = (value: any): string => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    const escaped = str.replace(/"/g, '""');
    return `"${escaped}"`;
  };

  const headerLine = headers.join(',');
  const lines = rows.map(row =>
    headers.map(h => escapeValue(row ? row[h] : '')).join(',')
  )

  return [headerLine, ...lines].join('\r\n');
}
